import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { DatePipe } from '@angular/common'
import { Loantransaction } from "./loantransaction.model";
import { Ledger} from "../../master/ledger/shared/ledger";
// import { Loanscheme } from "../../master/loan/shared/loanscheme.model";
// import { Loanreceipt } from "./loanreceipt";
// import { Installments } from "./installments.model";

@Injectable({
  providedIn: 'root'
})
export class LoantransactionService {

  public selectedLoantransaction: Loantransaction;
  public LoantransactionList: Loantransaction[];
  public selectedLedger: Ledger;

  constructor(private httpClient: HttpClient, private datePipe: DatePipe) {}

  getBaseUrl() {
    return environment.baseUrl;
  }

  // it is calling form RECIEPT
  IUDLoantransaction(loantransaction: Loantransaction) {

    loantransaction.CollectionAmount = ((loantransaction.PrincipleAmount *1) + (loantransaction.InterestAmount *1)) ;
    loantransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    loantransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    loantransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    loantransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    // loantransaction.CreatedDate  = new Date((localStorage.getItem("CreatedDate")));
    // loantransaction.ModifiedDate = new Date((localStorage.getItem("ModifiedDate")));
    loantransaction.CreatedDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    loantransaction.ModifiedDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    
    let body = loantransaction;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanTransaction/IUD', body, { headers: headers });
  }
  
  // save the transaction as list
  IUDLoantransactionList(LoantransactionList: Loantransaction[], form : any) {

    for (let i = 0; i < LoantransactionList.length; i++) {

      LoantransactionList[i].TransactionNo =+ form.value.TransactionNo;
      // LoantransactionList[i].TransactionDate =this.datePipe.transform(localStorage.getItem("ApplicationDate"), 'dd/MM/yyyy');
      LoantransactionList[i].TransactionDate = form.value.TransactionDate;
      LoantransactionList[i].CentreId = + form.value.CentreId;
      LoantransactionList[i].PaymentTypeId = + form.value.PaymentTypeId;
      LoantransactionList[i].PaymentBankId = + form.value.PaymentBankId;      
      LoantransactionList[i].IsActive = form.value.IsActive;
      LoantransactionList[i].Remarks  = "From Loan Collection/Transaction List";

      LoantransactionList[i].CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
      LoantransactionList[i].EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
      LoantransactionList[i].EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
      LoantransactionList[i].SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    }

    let body = LoantransactionList;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanTransaction/IUDList', body, { headers: headers });
  }

   // it is calling form Transaction Add Form
  FetchLoantransactionByCentre( CentreId : any, ) {
    // this.selectedLoantransaction= new  Loantransaction();
    this.selectedLoantransaction.CentreId = CentreId;
    this.selectedLoantransaction.ListByCentreId = true; // -- using to get loanee payments by centre Id
    
  // this.selectedLoantransaction.TransactionDate = this.datePipe.transform(localStorage.getItem("ApplicationDate"), 'dd/MM/yyyy');
    this.selectedLoantransaction.TransactionDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
   
    this.selectedLoantransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoantransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoantransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoantransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body =  this.selectedLoantransaction;

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanTransaction/FetchList', body, { headers: headers });
  }

   // it is calling form RECIEPT
  FetchLoantransactionList(ToReceiptForm: any ){
    this.selectedLoantransaction = new  Loantransaction();
    this.selectedLoantransaction.IsReceiptAmount = ToReceiptForm;  // distinguish Receipt or transactions page.
    this.selectedLoantransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoantransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoantransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoantransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body =  this.selectedLoantransaction;

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanTransaction/FetchList', body, { headers: headers });
  }

  //  PrintloantransactionlistService is using to generate receipt.
  FetchReportLoantransactionList(ToReceiptForm:any,loanTransactionItem: any){

    // console.log(loanTransactionItem);
    // console.log(loanTransactionItem.TransactionNo);
    if(!ToReceiptForm) {
    this.selectedLoantransaction.ListByCentreId = true;
    }
    else{
      this.selectedLoantransaction.IsReceiptAmount = true;
    } 
    this.selectedLoantransaction.Id =+ loanTransactionItem.Id;
    this.selectedLoantransaction.TransactionNo = + loanTransactionItem.TransactionNo;
    this.selectedLoantransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoantransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoantransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoantransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body =  this.selectedLoantransaction;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanTransaction/Report', body, { headers: headers });
  }

  FetchBankLedgerList(){
    
    this.selectedLedger  = new Ledger();
    this.selectedLedger.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLedger.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLedger.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.selectedLedger.IsBranchWise = true;

    let body =  this.selectedLedger;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/Ledger/FetchList', body,{headers: headers});
   }

  // Receipt print
  // FetchReportLoanReceipt(loanTransactionItem: any){

  //     this.selectedLoantransaction = new Loantransaction();
  //     this.selectedLoantransaction.Id =+ loanTransactionItem.Id;
  //     this.selectedLoantransaction.IsReceiptAmount = true;
  //     this.selectedLoantransaction.TransactionNo =+ loanTransactionItem.TransactionNo;
  //     this.selectedLoantransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
  //     this.selectedLoantransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  //     this.selectedLoantransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
  //     this.selectedLoantransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
  //     let body =  this.selectedLoantransaction;
  //     const headers = new HttpHeaders();
  //     headers.set('Content-Type', 'application/json; charset=utf-8');
  //     return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanTransaction/Report', body, { headers: headers });
  //   }

  }

